import AddStudentBtn from "../../../assets/images/add_studentBtn.png";
import HomeTabLesson from "../../../assets/images/home_tab_lesson.png";
import HomeTabHomework from "../../../assets/images/home_tab_homework.png";
import {useRecoilState, useRecoilValue} from "recoil";
import {homeSubMenuState} from "../../../recoil/home/homeState";

const HomeTop = ({auth, mainClass, studentsCount, selectMenu, homeTab, setHomeTab}) =>{


    return (
        <div className="flex flex-col gap-8">
            <div className="flex flex-row items-center justify-center gap-4  text-[#50555F] text-[24px] font-[700]">
                <div className="flex">
                    {auth.teacher.name} 선생님
                </div>
                <div className="w-[2px] h-[20px] border-[1px] border-[#B0B2B8]"></div>
                <div className="flex h-[34px] items-center font-[500]">
                    {mainClass && mainClass.name}
                </div>
                <div className="w-[2px] h-[20px] border-[1px] border-[#B0B2B8]"></div>
                <div className="flex flex-row">
                    <div className="flex text-[#355BDF] h-[34px] items-center">
                        {studentsCount}명
                    </div>
                    <img
                        src={AddStudentBtn}
                        alt="add student btn"
                        className="w-[34px] ml-[6px] cursor-pointer"
                        onClick={() => selectMenu("management")}
                    />
                </div>
            </div>
            <div className="flex flex-row items-center justify-center gap-3 relative">
                {homeTab === "lesson" ? (
                    <div className="flex relative w-[375px] h-max">
                        <img
                            src={HomeTabLesson}
                            alt="home tab lesson"
                        />
                        <div className="flex w-[187px] h-full absolute cursor-pointer right-0"
                             onClick={() => {selectMenu("homeHomework"); setHomeTab("homework"); }}
                        ></div>
                    </div>
                ) : (
                    <div className="flex relative w-[375px] h-max">
                        <img
                            src={HomeTabHomework}
                            alt="home tab homework"
                        />
                        <div className="flex w-[187px] h-full absolute cursor-pointer left-0"
                            onClick={() =>  {selectMenu("home"); setHomeTab("lesson"); }}
                        ></div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default HomeTop;